<template>
  <div class="main">
    <el-tabs v-model="activeName" type="card" class="cardTabs">
      <el-tab-pane label="基本信息" name="first" class="cardPane">
        <el-form ref="addFormRef" :model="addForm" :rules="rules" class="formDiv">
          <el-form-item label="甲方统一社会信用代码" label-width="2.1rem"  class="formItem">
            <el-input v-model="addForm.partyASocialCreditCode"></el-input>
          </el-form-item>
          <el-form-item label="甲方委托代理人/联系电话" label-width="2.4rem"  class="formItem">
            <el-input v-model="addForm.partyAEntrustedAgent"></el-input>
          </el-form-item>
          <el-form-item label="甲方法定代表人" label-width="2.1rem"  class="formItem">
            <el-input v-model="addForm.partyALegalRepresentative"></el-input>
          </el-form-item>
          <el-form-item label="甲方联系人/联系地址/邮编" label-width="2.4rem" class="formItem">
            <el-input v-model="addForm.partyAContactPerson"></el-input>
          </el-form-item>
          <el-form-item label="乙方统一社会信用代码" label-width="2.1rem"  class="formItem">
            <el-input v-model="addForm.partyBSocialCreditCode"></el-input>
          </el-form-item>
          <el-form-item label="乙方委托代理人/联系电话" label-width="2.4rem" class="formItem">
            <el-input v-model="addForm.partyBEntrustedAgent"></el-input>
          </el-form-item>
          <el-form-item label="乙方法定代表人" label-width="2.1rem" class="formItem">
            <el-input v-model="addForm.partyBLegalRepresentative"></el-input>
          </el-form-item>
          <el-form-item label="乙方联系人/联系地址/邮编" label-width="2.4rem"  class="formItem">
            <el-input v-model="addForm.partyBContactPerson"></el-input>
          </el-form-item>
          <el-form-item label="合同编号" label-width="1.2rem" prop="contractNumber" class="formItem">
            <el-input v-model="addForm.contractNumber" auto-complete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="合同名称" label-width="1.2rem" prop="contractName" class="formItem">
            <el-input v-model="addForm.contractName"></el-input>
          </el-form-item>
          <el-form-item label="所属公司" label-width="1.2rem"  class="formItem">
            <el-select v-model="addForm.companyId" placeholder="请选择所属公司">
              <el-option
                  v-for="item in companyValueList"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出租楼宇" label-width="1.2rem" prop="buildingId" class="formItem">
            <el-select v-model="addForm.buildingId" placeholder="请选择出租楼宇">
              <el-option
                  v-for="item in rentalBuildingList"
                  :key="item.buildingId"
                  :label="item.buildingName"
                  :value="item.buildingId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同模板" label-width="1.2rem" prop="templateNumber" class="formItem">
            <el-select v-model="addForm.templateNumber" placeholder="请选择合同模板">
              <el-option
                  v-for="item in contractTypeList"
                  :key="item.templateNumber"
                  :label="item.templateName"
                  :value="item.templateNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产权证号" label-width="1.2rem"  class="formItem">
            <el-input v-model="addForm.official_number"></el-input>
          </el-form-item>
          <el-form-item label="出租详情" label-width="1.2rem" prop="rentalDetailAddr" class="formItemDetail">
            <el-input v-model="addForm.building_name" style="display:inline" placeholder="出租楼宇地址"></el-input>
            <el-input v-model="addForm.rentalDetailAddr" style="display:inline;margin-left: .1rem" placeholder="出租详细楼层、室号等"></el-input>
          </el-form-item>
          <el-form-item label="房屋用途" label-width="1.2rem" class="formItemRemark" >
            <el-input type="textarea" :rows="3" v-model="addForm.housingUse"></el-input>
          </el-form-item>
          <el-form-item label="建筑面积" label-width="1.2rem" prop="contractOfficialArea" class="formItemArea">
            <el-input v-model="addForm.contractOfficialArea"></el-input><div class="unit">平方米</div>
          </el-form-item>
          <el-form-item label="租赁面积" label-width="1.2rem"  class="formItemArea">
            <el-input v-model="addForm.contractRentalArea"></el-input><div class="unit">平方米</div>
          </el-form-item>
          <el-form-item label="甲方(出租方)" label-width="1.4rem" prop="partA" class="formItem">
            <el-input v-model="addForm.partA" placeholder="甲方"></el-input>
          </el-form-item>
          <el-form-item label="乙方(承租方)" label-width="1.4rem" prop="partB" class="formItem">
            <el-input v-model="addForm.partB"></el-input>
          </el-form-item>
          <el-form-item label="备注" label-width="1.2rem" class="formItemRemark" >
            <el-input type="textarea" :rows="3" v-model="addForm.remark"></el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="合同信息" name="second" class="cardPane">
        <p class="title">一、租赁期限和房屋交付日期</p>
        <el-form ref="addFormRef" :model="addForm" :rules="rules" class="formDiv">
          <el-form-item label="合同期限" label-width="1.2rem" prop="contractPeriod" class="formItemTime">
            <el-input v-model="addForm.contractPeriod" class="input"></el-input>
            <div class="text">年，</div>
            <el-date-picker
                v-model="addForm.contractDate"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="起，至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
<!--            <el-date-picker-->
<!--                v-model="addForm.contract_start_date"-->
<!--                value-format="yyyy-MM-dd"-->
<!--                type="date"-->
<!--                placeholder="年/月/日">-->
<!--            </el-date-picker>-->
<!--            <div class="text">起，至</div>-->
<!--            <el-date-picker-->
<!--                v-model="addForm.contract_end_date"-->
<!--                value-format="yyyy-MM-dd"-->
<!--                type="date"-->
<!--                placeholder="年/月/日">-->
<!--            </el-date-picker>-->
            <div class="text">止</div>
          </el-form-item>
          <el-form-item label="房屋交付日期" label-width="1.2rem" prop="houseDeliveryDate" class="formItemDelivery">
            <el-date-picker
                v-model="addForm.houseDeliveryDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="年/月/日">
            </el-date-picker>
          </el-form-item>
        <p class="title">二、租金、免租期、保证金</p>
          <el-form-item label="日租金" label-width="1.2rem" prop="daliyRental" class="formItemMoneyDay">
            <!-- <el-input v-model="addForm.daliyRental" :placeholder="getSection()"></el-input><div class="unit">元</div> -->
            <el-input v-model="addForm.daliyRental"></el-input><div class="unit">元</div>
          </el-form-item>
          <el-form-item label="月租金" label-width="1.2rem" class="formItemMoneyYear">
            <el-input v-model="addForm.monthlyRental" ></el-input><div class="unit">元</div>
          </el-form-item>
          <el-form-item label="年租金" label-width="1.2rem" class="formItemMoneyYear">
            <el-input v-model="addForm.yearRental" ></el-input><div class="unit">元</div>
          </el-form-item>
          <el-form-item label="租金递增" label-width="1.2rem" class="formItemMoneyYear">
            <el-input v-model="addForm.increasingRent" ></el-input><div class="unit">元</div>
          </el-form-item>
          <el-form-item label="保证金月数" label-width="1.2rem" class="formItemMoneyYear">
            <el-input v-model="addForm.marginMonths" ></el-input><div class="unit">月</div>
          </el-form-item>
          <el-form-item label="免租期" label-width="1.2rem" prop="rentFreePeriod" class="formItemTime">
            <el-input v-model="addForm.rentFreePeriod" @blur="blurText($event)" class="input"></el-input>
            <div class="text">个月，</div>
            <el-date-picker
                v-model="addForm.rentFreeDate"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="起，至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <div class="text">止</div>
          </el-form-item>
          <el-form-item label="乙方应自" label-width="1.2rem" prop="rentalStartDate" class="formItemCalculateRent">
            <el-date-picker
                v-model="addForm.rentalStartDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="年/月/日">
            </el-date-picker>
            <div class="text">起计算租金，租金每</div>
            <el-input v-model="addForm.rentalPayCycle"></el-input>
            <div class="text">个月支付一次</div>
          </el-form-item>
          <el-form-item label="价格审批单">
            <div class="text1" style="display:flex"><uploadFile :isMessage="false" customText="(日租金超出楼宇设置租金额度该字段则必上传附件)" @handleFile="handleFile" :attachmentUrlList="addForm.attachmentUrl" :isFileType="['file', 'img']"></uploadFile></div>
          </el-form-item>
          <p class="title">乙方支付（人民币）：</p>
          <el-form-item label="保证金" label-width="1.3rem" prop="securityDeposit" class="formItemMoney">
            <el-input v-model="addForm.securityDeposit"></el-input><div class="unit">元</div>
          </el-form-item>
          <el-form-item label="首期房屋租金" label-width="1.3rem"  class="formItemTime">
            <el-input v-model="addForm.firstPhaseRental" class="input"></el-input>
            <div class="text">元，（自</div>
            <el-date-picker
                v-model="addForm.firstPhaseDate"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <div class="text">）</div>
          </el-form-item>
          <el-form-item label="物业管理费" label-width="1.3rem" prop="firstPhaseManageFee" class="formItemTime">
            <el-input v-model="addForm.firstPhaseManageFee" class="input"></el-input>
            <div class="text">元，（自</div>
            <el-date-picker
                v-model="addForm.firstPhaseManageFeeDate"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <div class="text">）</div>
          </el-form-item>
          <el-form-item label="首期房屋租金和物业管理费合计" label-width="2.2rem" prop="firstPhaseRentalManagefeeSum" class="formItemMoney">
            <el-input v-model="addForm.firstPhaseRentalManagefeeSum" disabled></el-input><div class="unit">元</div>
          </el-form-item>
          <el-form-item label="首期保证金、房屋租金和物业管理费合计" label-width="2.8rem" prop="firstPhaseFeeSum" class="formItemMoney">
            <el-input v-model="addForm.firstPhaseFeeSum" disabled></el-input><div class="unit">元</div>
          </el-form-item>
          <p class="title">甲方收款账户：{{addForm.partA}}</p>
          <el-form-item label="银行账号" label-width="1.2rem" prop="openingBankAccount" class="formItem">
            <!--            <el-input v-model="addForm.openingBankAccount" class="input"></el-input>-->
            <el-select v-model="addForm.openingBankAccount" placeholder="请选择">
              <el-option
                  v-for="item in openingBankList"
                  :key="item.openingBankAccount"
                  :label="item.openingBankAccount"
                  :value="item.openingBankAccount">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行账户" label-width="1.2rem" prop="openingBank" class="formItem">
            <el-input v-model="addForm.openingBank" class="input"></el-input>
          </el-form-item>
        </el-form>
        <p class="title" style="display: inline-block">《租金价目表》（人民币）</p>
        <el-button class="tableBtn" @click="addRow()" type="text" size="small" style="display: inline-block;margin-left: .1rem">添加一行</el-button>
        <el-table
            v-loading="loading"
            :data="tableData"
            :default-sort = "{prop: 'id', order: 'descending'}"
            style="width: 100%"
            :highlight-current-row="false"
            :header-cell-style="{background:'#F4F7FA',color:'#606266'}"
            class="tableInput">
<!--          <el-table-column label="项目" width="100" v-if="isEdit">-->
<!--            <template slot-scope="scope">-->
<!--              <div>-->
<!--                {{scope.row.id}}-->
<!--              </div>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="租赁开始时间" width="160">
            <template slot-scope="scope">
              <el-date-picker
                  v-model="scope.row.rentalStartDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="年/月/日"
                  clearable>
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column label="租赁结束时间" width="160">
            <template slot-scope="scope">
              <el-date-picker
                  v-model="scope.row.rentalEndDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="年/月/日"
                  clearable>
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column label="每期租金（元）" width="170">
            <template slot-scope="scope">
              <el-input
                  placeholder="请输入每期租金"
                  v-model="scope.row.rentalUnit"
                  maxlength="400"
                  clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="租金总额（元）" width="170">
            <template slot-scope="scope">
              <el-input
                  placeholder="请输入租金总额"
                  v-model="scope.row.rentalSum"
                  maxlength="300"
                  clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="日租金（元/天/平米）" width="170">
            <template slot-scope="scope">
              <el-input
                  placeholder="请输入日租金"
                  v-model="scope.row.dailyRental"
                  maxlength="400"
                  clearable>
              </el-input>
            </template>
          </el-table-column>
<!--          <el-table-column label="物业管理费（元）" width="170">-->
<!--            <template slot-scope="scope">-->
<!--              <el-input-->
<!--                  placeholder="请输入物业管理费"-->
<!--                  v-model="scope.row.manageFee"-->
<!--                  maxlength="400"-->
<!--                  clearable>-->
<!--              </el-input>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="备注" width="200">
            <template slot-scope="scope">
              <el-input
                  placeholder="请输入备注"
                  v-model="scope.row.remark"
                  maxlength="400"
                  clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="110">
            <template slot-scope="scope" class="tableButton">
              <el-button class="tableBtn" @click="deleteRow(scope.$index)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="content">
          <div class="word">1.本价目表中的租金总额以租赁面积</div>
          <div class="input">
            <el-input v-model="addForm.contractRentalRelationArea"></el-input>
          </div>
          <div class="word">平方米为前提计算。租金计算公式为房屋建筑面积*日租金*365天。</div>
        </div>
        <div class="content">
          <div class="word">2.本价目表信息一经提交，无法修改，请慎重计算！</div>
        </div>
        <div class="btnDiv">
          <el-button type="primary" @click="saveFun">保存</el-button>
          <el-button class="searchBtn" type="primary" @click="previewFun" v-if="isEdit">预览</el-button>
          <!-- <el-button class="searchBtn" type="primary" @click="submitFun">提交审批</el-button> -->
          <el-button class="searchBtn" @click="goback">返回</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!--    保存 弹框-->
    <div class="dialogDiv">
      <el-dialog
          :title="eventControl"
          :visible.sync="saveVisible"
          center>
        <span>保存后将存储为草稿，是否立即保存</span>
        <div slot="footer" class="dialog-footer">
          <el-button @click="saveVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveForm()">确 认</el-button>
        </div>
      </el-dialog>
    </div>
    <!--    审批 弹框-->
    <div class="dialogDiv">
      <el-dialog
          :title="eventControl"
          :visible.sync="submitVisible"
          center>
        <div style="margin-bottom: .2rem">
          <span style="margin-right: .2rem">审批结果:</span>
          <el-radio v-model="approved" :label="true">同意</el-radio>
          <el-radio v-model="approved" :label="false">驳回</el-radio>
        </div>
        <span style="margin-right: .2rem">审批意见:</span>
        <el-input
            type="textarea"
            style="width: 65%;vertical-align:top;"
            :autosize="{ minRows: 3, maxRows: 5}"
            placeholder="请输入内容"
            v-model="approvalText">
        </el-input>
        <div slot="footer" class="dialog-footer">
          <el-button @click="submitVisible = false">取 消</el-button>
          <el-button type="primary" @click="approveForm()">确 认</el-button>
        </div>
      </el-dialog>
    </div>
    <!--    提交(招商员) 弹框-->
    <div class="dialogDiv">
      <el-dialog
          :title="eventControl"
          :visible.sync="submitVisibleOffice"
          center>
        <span>提交意见:</span>
        <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 5}"
            placeholder="请输入内容"
            v-model="approvalText">
        </el-input>
        <div slot="footer" class="dialog-footer">
          <el-button @click="submitVisibleOffice = false">取 消</el-button>
          <el-button type="primary" @click="approveForm(1)">确 认</el-button>
        </div>
      </el-dialog>
    </div>
    <!--    预览时内容弹框-->
    <div class="previewDialogDiv">
      <el-dialog
          :visible.sync="previewVisible"
          center>
        <p class="ql-editor" v-html="content"></p>
        <br />
        <div class="title" style="width: 2.5rem;margin: 0 auto;">《租金价目表》（人民币）</div>
        <el-table
            v-loading="loading"
            :data="previewTableData"
            border
            :default-sort = "{prop: 'id', order: 'descending'}"
            style="width: 100%"
            :highlight-current-row="false">
          <template v-for="(item, index) in previewTableColumns">
            <el-table-column
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width">
            </el-table-column>
          </template>
        </el-table>
        <div class="content">
          <div class="word">1.本价目表中的租金总额以租赁面积 {{contractRentalRelationArea}} 平方米为前提计算。租金计算公式为房屋建筑面积*日租金*365天。</div>
          <div class="word">2.本价目表信息一经提交，无法修改，请慎重计算！</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { listCompanyBuildingTemplateBriefInfo } from '@/api/searchList'
import { addContractInfo, updateContractInfo, addContractApprove, queryContractDetail, previewContractDetail, tempQuery } from '@/api/contract'
import base from '@/utils/index'
import { Message } from 'element-ui'
import uploadFile from '../../components/upload/uploadFile.vue'
export default {
  name: 'addContract',
  components: {
    uploadFile
  },
  data () {
    return {
      loading: false,
      activeName: 'first',
      companyValueList: [],
      contractTypeList: [],
      rentalBuildingList: [],
      openingBankList: [],
      ownerList: [],
      areaValue: '',
      eventControl: '',
      isFlag: false,
      saveVisible: false, // 保存弹框
      submitVisible: false, // 审批弹框
      submitVisibleOffice: false, // 提交弹框
      previewVisible: false, // 预览弹框
      approvalText: '',
      isEdit: this.$route.query.isEdit,
      id: this.$route.query.id,
      roleName: '',
      minDailyRental: 0,
      maxDailyRental: 0,
      chooseBuilding: false,
      contractRentalAreaCount: '',
      toCode: false,
      addForm: {
        contractNumber: '',
        contractName: '',
        companyId: '',
        templateNumber: '',
        buildingId: '',
        building_name: '',
        official_number: '',
        rentalDetailAddr: '',
        contractOfficialArea: '',
        contractRentalArea: '',
        partA: '',
        partB: '',
        remark: '',
        contractPeriod: '',
        contract_start_date: '',
        contract_end_date: '',
        houseDeliveryDate: '',
        daliyRental: '',
        yearRental: '',
        rentFreePeriod: '',
        rent_free_start_date: '',
        rent_free_end_date: '',
        rentalStartDate: '',
        rentalPayCycle: '',
        securityDeposit: '',
        firstPhaseRental: '',
        first_phase_start_date: '',
        first_phase_end_date: '',
        firstPhaseManageFee: '',
        first_phase_manage_fee_start_date: '',
        first_phase_manage_fee_end_date: '',
        firstPhaseRentalManagefeeSum: '',
        firstPhaseFeeSum: '',
        openingBank: '',
        openingBankAccount: '',
        contractRentalRelationArea: '',
        contractDate: [],
        rentFreeDate: [],
        firstPhaseDate: [],
        firstPhaseManageFeeDate: [],
        attachmentUrl: '',
        partyASocialCreditCode: '',
        partyAEntrustedAgent: '',
        partyALegalRepresentative: '',
        partyAContactPerson: '',
        partyBSocialCreditCode: '',
        partyBEntrustedAgent: '',
        partyBLegalRepresentative: '',
        partyBContactPerson: '',
        housingUse: '',
        monthlyRental: '',
        increasingRent: '',
        marginMonths: '',
      },
      rules: {
        contractNumber: [{ required: true, message: '请填写', trigger: 'blur' }],
        contractName: [{ required: true, message: '请填写', trigger: 'blur' }],
        companyId: [{ required: true, message: '请填写', trigger: 'blur' }],
        templateNumber: [{ required: true, message: '请填写', trigger: 'blur' }],
        buildingId: [{ required: true, message: '请填写', trigger: 'blur' }],
        rentalDetailAddr: [{ required: true, message: '请填写', trigger: 'blur' }],
        contractOfficialArea: [{ required: true, message: '请填写', trigger: 'blur' }],
        // firstPhaseFeeSum: [{ required: true, message: '请填写', trigger: 'blur' }],
        contractRentalArea: [{ required: true, message: '请填写', trigger: 'blur' }],
        partA: [{ required: true, message: '请填写', trigger: 'blur' }],
        partB: [{ required: true, message: '请填写', trigger: 'blur' }],
        contractPeriod: [{ required: true, message: '请填写', trigger: 'blur' }],
        houseDeliveryDate: [{ required: true, message: '请填写', trigger: 'blur' }],
        // 日租金
        daliyRental: [{ required: true,
          message: '请填入正确值',
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error('值不能为空'))
            }
            // if (parseFloat(value) > this.maxDailyRental || parseFloat(value) < this.minDailyRental) {
            //   return callback(new Error('请填入正确值'))
            // }
          } }],
        // rentFreePeriod: [{ required: true, message: '请填写', trigger: 'blur' }],
        rentalStartDate: [{ required: true, message: '请填写', trigger: 'blur' }],
        securityDeposit: [{ required: true, message: '请填写', trigger: 'blur' }],
        firstPhaseRental: [{ required: true, message: '请填写', trigger: 'blur' }],
        // firstPhaseManageFee: [{ required: true, message: '请填写', trigger: 'blur' }],
        // firstPhaseRentalManagefeeSum: [{ required: true, message: '请填写', trigger: 'blur' }],
        openingBank: [{ required: true, message: '请填写', trigger: 'blur' }],
        openingBankAccount: [{ required: true, message: '请填写', trigger: 'blur' }]
      },
      tableData: [
        {
        },
        {
        },
        {
        }
      ],
      approved: undefined,
      // 预览的表格数据
      previewTableData: [],
      previewTableColumns: [
        // {
        //   prop: 'id',
        //   label: '项目'
        // },
        {
          prop: 'rentalDate',
          label: '租赁期限',
          width: '200px'

        },
        {
          prop: 'rentalUnit',
          label: '每期租金（元）'
        },
        {
          prop: 'rentalSum',
          label: '租金总额（元）'
        },
        {
          prop: 'dailyRental',
          label: '日租金（元/天/平米）'
        },
        // {
        //   prop: 'manageFee',
        //   label: '物业管理费（元）'
        // },
        {
          prop: 'remark',
          label: '备注'
        }
      ],
      contractRentalRelationArea: '', // 预览最后的租赁面积参数
      content: '', // 预览内容
      firstPhaseRentalManagefeeSumValue: '' // 用于监听计算
    }
  },
  mounted () {
    const baseFunc = base()
    this.roleName = baseFunc.getLocalStorage('userInfo_roleName')
    this.getCompanyList()
    this.getAllTemplate()
    this.isEdit = this.$route.query.isEdit === true || this.$route.query.isEdit === 'true'
    if (this.isEdit) {
      // 合同信息接口
      this.editContractInfo(this.id)
    }
  },
  computed: {
    // 监听首期房屋租金、物业管理费变化
    changeData () {
      let { firstPhaseRental, firstPhaseManageFee } = this.addForm
      return {
        firstPhaseRental,
        firstPhaseManageFee
      }
    },
    // 监听保证金、首期房屋租金、物业管理费变化
    changeDataThree () {
      let { securityDeposit, firstPhaseRental, firstPhaseManageFee } = this.addForm
      return {
        securityDeposit,
        firstPhaseRental,
        firstPhaseManageFee
      }
    }
  },
  watch: {
    // 监听首期房屋租金，物业管理费变化，自动填充首期房屋租金和物业管理费
    changeData: {
      handler (v) {
        if (v) {
          this.firstPhaseRentalManagefeeSumValue = parseFloat(v.firstPhaseRental) + parseFloat(v.firstPhaseManageFee)
          if (isNaN(this.firstPhaseRentalManagefeeSumValue)) {
            this.addForm.firstPhaseRentalManagefeeSum = ''
          } else {
            this.addForm.firstPhaseRentalManagefeeSum = this.firstPhaseRentalManagefeeSumValue
          }
        }
      },
      deep: true,
      immediate: true
    },
    // 监听保证金，首期房屋租金，物业管理费变化，自动填充保证金、首期房屋租金和物业管理费
    changeDataThree: {
      handler (v) {
        if (v) {
          this.firstPhaseFeeSumValue = parseFloat(v.securityDeposit) + parseFloat(v.firstPhaseRental) + parseFloat(v.firstPhaseManageFee)
          if (isNaN(this.firstPhaseFeeSumValue)) {
            this.addForm.firstPhaseFeeSum = ''
          } else {
            this.addForm.firstPhaseFeeSum = this.firstPhaseFeeSumValue
          }
        }
      },
      deep: true,
      immediate: true
    },

    'addForm.houseDeliveryDate': {
      handler (newvalue) {
        console.log(this.addForm.contractDate[0])
        console.log(newvalue)
        if (newvalue < this.addForm.contractDate[0]) {
          Message.error('房屋交付时间不得早于合同时间')
          this.addForm.houseDeliveryDate = ''
        }
      }
    },

    // 租赁面积
    'addForm.contractRentalArea': {
      handler (v) {
        if (v) {
          this.contractRentalAreaCount = v
        }
      },
      deep: true,
      immediate: false
    },
    // 选择所属公司后，对应出租楼宇list
    'addForm.companyId': {
      handler (v) {
        if (v) {
          this.rentalBuildingList = this.companyValueList.filter(i => i.companyId === v)[0].buildingTemplateBriefInfoList
          this.addForm.partA = this.companyValueList.filter(i => i.companyId === v)[0].companyName
          this.openingBankList = this.companyValueList.filter(i => i.companyId === v)[0].companyBankBriefInfoList
        } else {
          this.addForm.buildingId = ''
          this.rentalBuildingList = []
          this.openingBankList = []
          // this.minDailyRental = 0
          // this.maxDailyRental = 0
        }
      },
      deep: true,
      immediate: false
    },
    // 选择出租楼宇后，对应合同模板list，和对应日租金最大最小值，和建筑面积
    'addForm.buildingId': {
      handler (v) {
        if (v) {
          // this.contractTypeList = this.rentalBuildingList.filter(i => i.buildingId === v)[0].templateBriefInfoList
          this.addForm.building_name = this.rentalBuildingList.filter(i => i.buildingId === v)[0].buildingName
          this.addForm.official_number = this.rentalBuildingList.filter(i => i.buildingId === v)[0].officialNumber
          // 日租金的最大值和最小值设置
          this.minDailyRental = this.rentalBuildingList.filter(i => i.buildingId === v)[0].minDailyRental
          this.maxDailyRental = this.rentalBuildingList.filter(i => i.buildingId === v)[0].maxDailyRental
          this.chooseBuilding = true
          // 建筑面积
          this.addForm.contractOfficialArea = this.rentalBuildingList.filter(i => i.buildingId === v)[0].officialArea
        } else {
          this.addForm.templateNumber = ''
          this.contractTypeList = []
          this.chooseBuilding = false
        }
      },
      deep: true,
      immediate: false
    },
    // 选择银行号后，对应出银行账户
    'addForm.openingBankAccount': {
      handler (v) {
        if (v) {
          this.addForm.openingBank = this.openingBankList.filter(i => i.openingBankAccount === v)[0].openingBank
        } else {
          this.addForm.openingBank = ''
        }
      },
      deep: true,
      immediate: false
    },
    // 填写日租金后，年租金自动计算
    'addForm.daliyRental': {
      handler (v) {
        if (v) {
          // console.log(typeof parseFloat(this.addForm.daliyRental))
          if (this.isEdit) {
            this.addForm.yearRental = (v * 365 * this.addForm.contractRentalArea).toFixed(2)
          } else {
            this.addForm.yearRental = (v * 365 * this.contractRentalAreaCount).toFixed(2)
          }
        } else {
          this.addForm.yearRental = ''
        }
      },
      deep: true,
      immediate: false
    }
  },
  beforeRouteLeave (to, form, next) {
    if (!this.toCode) {
      this.$confirm('要离开当前页面, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        next()
      })
    } else {
      next()
    }
  },
  methods: {
    handleFile(imgs) {
      let arrFile = imgs.map(v => v.code).join(',')
      this.addForm.attachmentUrl = arrFile
    },
    blurText (e) {
      let boolean = new RegExp('^(0|[1-9][0-9]*)$').test(e.target.value)
      if (!boolean) {
        Message({
          message: '请输入正整数',
          type: 'warning'
        })
        e.target.value = ''
      }
    },
    blurDaliyRental (e) {
      let boolean = new RegExp('^(-?\\d+)(\\.\\d+)?$').test(e.target.value)
      if (!boolean) {
        Message({
          message: '请输入数字',
          type: 'warning'
        })
        e.target.value = ''
      }
      // if (e.target.value > this.maxDailyRental || e.target.value < this.minDailyRental) {
      //   Message({
      //     message: '请填入正确值',
      //     type: 'warning'
      //   })
      // }
    },
    blurNumber (e) {
      let boolean = new RegExp('^(-?\\d+)(\\.\\d+)?$').test(e.target.value)
      if (!boolean) {
        Message({
          message: '请输入数字',
          type: 'warning'
        })
        e.target.value = ''
      }
    },
    // 获取日租金的区间
    getSection () {
      if (this.chooseBuilding) {
        return '请输入' + this.minDailyRental + '至' + this.maxDailyRental + '之间的值'
      } else {
        return '请输入'
      }
    },
    // 所属公司下拉框
    async getCompanyList () {
      let res = await listCompanyBuildingTemplateBriefInfo({
        related: false
      })
      if (res.code === 0) {
        this.companyValueList = res.result
      }
    },
    // 获取全部合同模板
    async getAllTemplate () {
      const params = {
          buildingId: '',
          templateName: '',
          pageNum: 1,
          pageSize: 9999
      }
      const data = await tempQuery(params)
      const { code, result } = data
      if (code === 0) {
        this.contractTypeList = result?.records || []
      }
    },
    // 《租金价目表》添加一行
    addRow () {
      this.tableData.push({
        // id: '',
        rentalStartDate: '',
        rentalEndDate: '',
        rentalUnit: '',
        rentalSum: '',
        dailyRental: '',
        // manageFee: '',
        remark: ''
      })
    },
    deleteRow (index) {
      this.tableData.splice(index, 1)
    },
    saveFun () {
      if (parseFloat(this.addForm.daliyRental) > this.maxDailyRental || parseFloat(this.addForm.daliyRental) < this.minDailyRental) {
        if (this.addForm.attachmentUrl === '') {
          Message({ message: '日租金超出楼宇设置租金额度该字段请上传附件', type: 'error' })
          return
        }
      }
      this.setIsShow()
      // this.saveVisible = true
      this.eventControl = '保存'
    },
    setIsShow() {
      // let list = [
      //   {
      //     label: '租赁合同建筑面积超出限制条件1000m2及以上的',
      //     value: 1000,
      //     under: '>',
      //     filed: 'contractOfficialArea'
      //   },
      //   {
      //     label: '租赁期限突破本规定上限的(合同租赁期限不超过三年)',
      //     value: 3,
      //     under: '<',
      //     filed: 'contractPeriod'
      //   },
      //   {
      //     label: '租赁合同免租期超过一个月的',
      //     value: 1000,
      //     under: '>',
      //     filed: 'rentFreePeriod'
      //   }
      // ]
      console.log(Number(this.addForm.contractOfficialArea));
      console.log(Number(this.addForm.contractOfficialArea) > 1000);
      console.log(this.addForm.contractPeriod);
      console.log(Number(this.addForm.contractPeriod) < 3);
      console.log(this.addForm.rentFreePeriod);
      console.log(Number(this.addForm.rentFreePeriod) < 1);
      if (Number(this.addForm.contractOfficialArea) > 1000 || Number(this.addForm.contractPeriod) > 3 || Number(this.addForm.rentFreePeriod) < 1) {
        this.$alert('<div> <div>1.租赁合同建筑面积超出限制条件1000m2及以上的</div> <div>2.租赁期限突破本规定上限的(合同租赁期限不超过三年)</div> <div>3.租赁合同免租期超过一个月的</div> <div>需要提交总公司审批</</div> </div>', '提示', {
          confirmButtonText: '确定',
          dangerouslyUseHTMLString: true,
          showClose: true,
          callback: action => {
            if (action === 'confirm') {
              this.saveForm()
            }
          }
        },);
      } else {
        this.saveVisible = true
      }
    },
    // 预览合同
    async previewFun () {
      let res = await previewContractDetail({
        id: this.id
      })
      if (res.code === 0) {
        let previewTableDataNew = []
        this.previewVisible = true
        this.content = res.result.contractFormatContent
        // this.previewTable = res.result.contractRentalRelationList
        res.result.contractRentalRelationList.forEach((item) => {
          previewTableDataNew.push({
            id: item.id,
            rentalDate: item.rentalStartDate + ' -- ' + item.rentalEndDate,
            rentalUnit: item.rentalUnit,
            rentalSum: item.rentalSum,
            dailyRental: item.dailyRental,
            manageFee: item.manageFee,
            remark: item.remark
          })
        })
        this.previewTableData = previewTableDataNew
        this.contractRentalRelationArea = res.result.contractRentalRelationArea
      }
    },
    submitFun () {
      if (parseFloat(this.addForm.daliyRental) > this.maxDailyRental || parseFloat(this.addForm.daliyRental) < this.minDailyRental) {
        if (this.addForm.attachmentUrl === '') {
          Message({ message: '日租金超出楼宇设置租金额度该字段请上传附件', type: 'error' })
          return
        }
      }
      if (this.roleName === '招商员') {
        this.submitVisibleOffice = true
        this.eventControl = '提交'
      } else {
        this.submitVisible = true
        this.eventControl = '提交审批'
      }
    },
    goback () {
      this.toCode = true // 跳转置为true
      this.$router.push('/contract/management')
    },
    // 编辑时显示合同信息
    async editContractInfo (id) {
      let res = await queryContractDetail({
        id: id
      })
      if (res.code === 0) {
        this.addForm = Object.assign({}, res.result,
          { contractDate: [res.result.contractStartDate, res.result.contractEndDate] },
          { firstPhaseManageFeeDate: [res.result.firstPhaseManageFeeStartDate, res.result.firstPhaseManageFeeEndDate] },
          { firstPhaseDate: [res.result.firstPhaseStartDate, res.result.firstPhaseEndDate] },
          { rentFreeDate: [res.result.rentFreeStartDate, res.result.rentFreeEndDate] }
        )
        this.tableData = res.result.contractRentalRelationList
      }
    },
    // 审批接口
    async approveForm (num) {
      if (num === 1) {
        this.approved = true
      }
      if (!this.isEdit) {
        // 新增合同状态下：先调保存接口，获得合同id；再调审批接口
        let resSave = await addContractInfo({
          buildingId: this.addForm.buildingId,
          companyId: this.addForm.companyId,
          contractName: this.addForm.contractName,
          contractNumber: this.addForm.contractNumber,
          contractOfficialArea: this.addForm.contractOfficialArea,
          contractPeriod: this.addForm.contractPeriod,
          contractRentalArea: this.addForm.contractRentalArea,
          contractRentalRelationArea: this.addForm.contractRentalRelationArea,
          contractRentalRelationEntityList: this.tableData,
          contractStartDate: this.addForm.contractDate[0],
          contractEndDate: this.addForm.contractDate[1],
          daliyRental: this.addForm.daliyRental,
          firstPhaseFeeSum: this.addForm.firstPhaseFeeSum,
          firstPhaseManageFee: this.addForm.firstPhaseManageFee,
          firstPhaseManageFeeStartDate: this.addForm.firstPhaseManageFeeDate[0],
          firstPhaseManageFeeEndDate: this.addForm.firstPhaseManageFeeDate[1],
          firstPhaseRental: this.addForm.firstPhaseRental,
          firstPhaseRentalManagefeeSum: this.addForm.firstPhaseRentalManagefeeSum,
          firstPhaseStartDate: this.addForm.firstPhaseDate[0],
          firstPhaseEndDate: this.addForm.firstPhaseDate[1],
          houseDeliveryDate: this.addForm.houseDeliveryDate,
          openingBank: this.addForm.openingBank,
          openingBankAccount: this.addForm.openingBankAccount,
          partA: this.addForm.partA,
          partB: this.addForm.partB,
          remark: this.addForm.remark,
          rentFreePeriod: this.addForm.rentFreePeriod,
          rentFreeStartDate: this.addForm.rentFreeDate[0],
          rentFreeEndDate: this.addForm.rentFreeDate[1],
          rentalDetailAddr: this.addForm.rentalDetailAddr,
          rentalPayCycle: this.addForm.rentalPayCycle,
          rentalStartDate: this.addForm.rentalStartDate,
          securityDeposit: this.addForm.securityDeposit,
          templateNumber: this.addForm.templateNumber,
          contractStatus: 0,
          attachmentUrl: this.addForm.attachmentUrl,
          partyASocialCreditCode: this.addForm.partyASocialCreditCode,
          partyAEntrustedAgent: this.addForm.partyAEntrustedAgent,
          partyALegalRepresentative: this.addForm.partyALegalRepresentative,
          partyAContactPerson: this.addForm.partyAContactPerson,
          partyBSocialCreditCode: this.addForm.partyBSocialCreditCode,
          partyBEntrustedAgent: this.addForm.partyBEntrustedAgent,
          partyBLegalRepresentative: this.addForm.partyBLegalRepresentative,
          partyBContactPerson: this.addForm.partyBContactPerson,
          housingUse: this.addForm.housingUse,
          monthlyRental: this.addForm.monthlyRental,
          increasingRent: this.addForm.increasingRent,
          marginMonths: this.addForm.marginMonths,
        })
        if (resSave.code === 0) {
          this.contractNumberSave = resSave.result.contractNumber
          await this.contractApprove(this.contractNumberSave, this.approved)
        } else {
          Message({
            message: resSave.message,
            type: 'error'
          })
        }
      } else {
        // 编辑合同状态下：先调‘更新接口’，获得合同id；再调审批接口
        let resSave = await updateContractInfo({
          id: Number(this.id),
          buildingId: this.addForm.buildingId,
          companyId: this.addForm.companyId,
          contractName: this.addForm.contractName,
          contractNumber: this.addForm.contractNumber,
          contractOfficialArea: this.addForm.contractOfficialArea,
          contractPeriod: this.addForm.contractPeriod,
          contractRentalArea: this.addForm.contractRentalArea,
          contractRentalRelationArea: this.addForm.contractRentalRelationArea,
          contractRentalRelationEntityList: this.tableData,
          contractStartDate: this.addForm.contractDate[0],
          contractEndDate: this.addForm.contractDate[1],
          daliyRental: this.addForm.daliyRental,
          firstPhaseFeeSum: this.addForm.firstPhaseFeeSum,
          firstPhaseManageFee: this.addForm.firstPhaseManageFee,
          firstPhaseManageFeeStartDate: this.addForm.firstPhaseManageFeeDate[0],
          firstPhaseManageFeeEndDate: this.addForm.firstPhaseManageFeeDate[1],
          firstPhaseRental: this.addForm.firstPhaseRental,
          firstPhaseRentalManagefeeSum: this.addForm.firstPhaseRentalManagefeeSum,
          firstPhaseStartDate: this.addForm.firstPhaseDate[0],
          firstPhaseEndDate: this.addForm.firstPhaseDate[1],
          houseDeliveryDate: this.addForm.houseDeliveryDate,
          openingBank: this.addForm.openingBank,
          openingBankAccount: this.addForm.openingBankAccount,
          partA: this.addForm.partA,
          partB: this.addForm.partB,
          remark: this.addForm.remark,
          rentFreePeriod: this.addForm.rentFreePeriod,
          rentFreeStartDate: this.addForm.rentFreeDate[0],
          rentFreeEndDate: this.addForm.rentFreeDate[1],
          rentalDetailAddr: this.addForm.rentalDetailAddr,
          rentalPayCycle: this.addForm.rentalPayCycle,
          rentalStartDate: this.addForm.rentalStartDate,
          securityDeposit: this.addForm.securityDeposit,
          templateNumber: this.addForm.templateNumber,
          attachmentUrl: this.addForm.attachmentUrl,
          partyASocialCreditCode: this.addForm.partyASocialCreditCode,
          partyAEntrustedAgent: this.addForm.partyAEntrustedAgent,
          partyALegalRepresentative: this.addForm.partyALegalRepresentative,
          partyAContactPerson: this.addForm.partyAContactPerson,
          partyBSocialCreditCode: this.addForm.partyBSocialCreditCode,
          partyBEntrustedAgent: this.addForm.partyBEntrustedAgent,
          partyBLegalRepresentative: this.addForm.partyBLegalRepresentative,
          partyBContactPerson: this.addForm.partyBContactPerson,
          housingUse: this.addForm.housingUse,
          monthlyRental: this.addForm.monthlyRental,
          increasingRent: this.addForm.increasingRent,
          marginMonths: this.addForm.marginMonths,
        })
        if (resSave.code === 0) {
          // this.contractNumberSave = resSave.result.contractNumber
          await this.contractApprove(this.addForm.contractNumber, this.approved)
        } else {
          Message({
            message: resSave.message,
            type: 'error'
          })
        }
      }
    },
    async contractApprove (data, approved) {
      // 然后调审批接口
      if (this.approved === undefined) {
        return Message({
          message: '请填写审批结果',
          type: 'warning'
        })
      }
      let res = await addContractApprove({
        approved: approved,
        contractNumber: data,
        processRemark: this.approvalText
      })
      if (res.code === 0) {
        this.toCode = true // 跳转置为true
        Message({
          message: '提交审批成功',
          type: 'success'
        })
        this.submitVisible = false
        this.submitVisibleOffice = false
        await this.$router.push('/contract/management')
      } else {
        Message({
          message: res.message,
          type: 'error'
        })
      }
    },
    async saveForm () {
      const params = {
        buildingId: this.addForm.buildingId,
        companyId: this.addForm.companyId,
        contractName: this.addForm.contractName,
        contractNumber: this.addForm.contractNumber,
        contractOfficialArea: this.addForm.contractOfficialArea,
        contractPeriod: this.addForm.contractPeriod,
        contractRentalArea: this.addForm.contractRentalArea,
        contractRentalRelationArea: this.addForm.contractRentalRelationArea,
        contractRentalRelationEntityList: this.tableData,
        contractStartDate: this.addForm.contractDate[0],
        contractEndDate: this.addForm.contractDate[1],
        daliyRental: this.addForm.daliyRental,
        firstPhaseFeeSum: this.addForm.firstPhaseFeeSum,
        firstPhaseManageFee: this.addForm.firstPhaseManageFee,
        firstPhaseManageFeeStartDate: this.addForm.firstPhaseManageFeeDate[0],
        firstPhaseManageFeeEndDate: this.addForm.firstPhaseManageFeeDate[1],
        firstPhaseRental: this.addForm.firstPhaseRental,
        firstPhaseRentalManagefeeSum: this.addForm.firstPhaseRentalManagefeeSum,
        firstPhaseStartDate: this.addForm.firstPhaseDate[0],
        firstPhaseEndDate: this.addForm.firstPhaseDate[1],
        houseDeliveryDate: this.addForm.houseDeliveryDate,
        openingBank: this.addForm.openingBank,
        openingBankAccount: this.addForm.openingBankAccount,
        partA: this.addForm.partA,
        partB: this.addForm.partB,
        remark: this.addForm.remark,
        rentFreePeriod: this.addForm.rentFreePeriod,
        rentFreeStartDate: this.addForm.rentFreeDate[0],
        rentFreeEndDate: this.addForm.rentFreeDate[1],
        rentalDetailAddr: this.addForm.rentalDetailAddr,
        rentalPayCycle: this.addForm.rentalPayCycle,
        rentalStartDate: this.addForm.rentalStartDate,
        securityDeposit: this.addForm.securityDeposit,
        templateNumber: this.addForm.templateNumber,
        contractStatus: 0,
        attachmentUrl: this.addForm.attachmentUrl,
        partyASocialCreditCode: this.addForm.partyASocialCreditCode,
          partyAEntrustedAgent: this.addForm.partyAEntrustedAgent,
          partyALegalRepresentative: this.addForm.partyALegalRepresentative,
          partyAContactPerson: this.addForm.partyAContactPerson,
          partyBSocialCreditCode: this.addForm.partyBSocialCreditCode,
          partyBEntrustedAgent: this.addForm.partyBEntrustedAgent,
          partyBLegalRepresentative: this.addForm.partyBLegalRepresentative,
          partyBContactPerson: this.addForm.partyBContactPerson,
          housingUse: this.addForm.housingUse,
          monthlyRental: this.addForm.monthlyRental,
          increasingRent: this.addForm.increasingRent,
          marginMonths: this.addForm.marginMonths,
      }
      const api = this.isEdit ? updateContractInfo : addContractInfo
      if (this.isEdit) {
        params.id = Number(this.id)
      }
      let res = await api(params) 
      if (res.code === 0) {
        this.toCode = true // 跳转置为true
        Message({
          message: '保存成功',
          type: 'success'
        })
        if (!this.isEdit) {
          this.contractNumberSave = res.result.contractNumber
        }
        this.saveVisible = false
        await this.$router.push('/contract/management')
      } else {
        Message({
          message: res.message,
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .main{
    padding: 0.2rem;
  }
  .cardTabs{
    padding-left: 1rem;
    padding-right: 1rem;
    .cardPane {
      margin-left: .5rem;
      margin-top: .3rem;
    }
      .formDiv{
        .formItem{
          display: inline-block;
          width: 5.2rem;
        }
        .formItemDetail{
          display: inline-block;
          width: 10.2rem;
          /deep/ .el-input__inner{
            width: 3.5rem;
          }
        }
        .formItemArea{
          display: inline-block;
          width: 5.2rem;
          /deep/ .el-input{
            display: inline;
          }
          .unit{
            display: inline;
            margin-left: .07rem;
          }
          /deep/ .el-input__inner{
            width: 2.7rem;
          }
        }
        .formItemRemark{
          display: inline-block;
          width: 9.9rem;
        }
        .formItemTime{
          display: inline-block;
          width: 12.2rem;
          position: relative;
          .text{
            display: inline-block;
            margin-right: .07rem;
            margin-left: .07rem;
          }
          .text1{
            position: absolute;
            top: 0;
            right: 0;
            margin-right: .1rem;
            margin-left: .5rem;
          }
          .input{
            display: inline-block;
            width: 1.8rem;
            /deep/ .el-input__inner{
              width: 1.8rem;
            }
          }
          /deep/ .el-range-separator{
            width: 15%;
          }
        }
        .formItemDelivery{
          display: inline-block;
          /deep/ .el-input__inner{
            width: 2.7rem;
          }
        }
        .formItemMoney{
          display: block;
          width: 6rem;
          /deep/ .el-input{
            display: inline;
          }
          .unit{
            display: inline;
            margin-left: .07rem;
          }
          /deep/ .el-input__inner{
            width: 2.7rem;
          }
        }
        .formItemMoneyDay{
          display:  inline-block;
          width: 4.5rem;
          /deep/ .el-input{
            display: inline;
          }
          .unit{
            display: inline;
            margin-left: .07rem;
          }
          /deep/ .el-input__inner{
            width: 2.7rem;
          }
        }
        .formItemMoneyYear{
          display:  inline-block;
          width: 4.5rem;
          /deep/ .el-input{
            display: inline;
          }
          .unit{
            display: inline;
            margin-left: .07rem;
          }
          /deep/ .el-input__inner{
            width: 2.7rem;
          }
        }
        .formItemCalculateRent{
          display: block;
          width: 8.2rem;
          /deep/ .el-date-editor{
            display: inline-block;
            width: 1.9rem;
          }
          .text{
            display: inline-block;
            margin-right: .07rem;
          }
          /deep/ .el-input{
            display: inline-block;
            width: 1.9rem;
          }
          /deep/ .el-input__inner{
            width: 1.8rem;
          }
        }
      }
    .title{
      display: block;
      font-weight:900;
      margin-bottom: .2rem;
    }
    .content{
      display: block;
      margin-top: .2rem;
      margin-bottom: .2rem;
      font-weight:600;
      .word{
        display: inline-block;
      }
      .input{
        display: inline-block;
      }
      /deep/ .el-input__inner {
        width: 1rem;
        height: .2rem;
        background-color: transparent;
        border-radius: 0;
        border-color: #111111;
        border-top-width: 0;
        border-left-width: 0;
        border-right-width: 0;
        border-bottom-width: .01rem;
      }
    }
  }
  .tableInput{
    /deep/ .el-date-editor{
      width: 1.4rem;
    }
  }
  .btnDiv{
    margin-top: .5rem;
    margin-bottom: .3rem;
    .searchBtn{
    margin-left: .5rem;
  }
  }
  /deep/ .el-table{
    background-color: #F7F8FA;
  }
  .el-table::before{
    height: 0;
  }
  .previewDialogDiv{
    /deep/ .el-dialog{
      width: 50%!important;
    }
  }

</style>
